// test1816
(1816 && 0);
